import { Product, Project } from "../redux/types/Project";

export interface AdminUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

export interface InsuranceCompany {
  id: number;
  companyName: string;
  companyLogo?: string;
  claimLink?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateInvoiceInput {
  projectId: number;
  productId: number;
  invoiceType: InvoiceType;
  name: string;
  description: string;
  amount: Float;
  date: string;
  identifier: string;
  url: string;
}

export interface UpdateInvoiceInput {
  invoiceId: number;
  projectId: number;
  productId: number;
  invoiceType: InvoiceType;
  name: string;
  description: string;
  amount: Float;
  date: string;
  identifier: string;
  url: string;
}

export type InvoiceType = "Material" | "Labor" | "AddOns";

export interface CreateAddOnsInput {
  projectId: number;
  addonName: string;
  description: string;
  price: number;
}

export interface EditAddOnsInput {
  addonId: number;
  addonName: string;
  description: string;
  price: number;
}

export interface ProjectInput {
  id: number;
}

export interface LeadsData {
  id: number;
  uuid?: string;
  streetAddress?: string;
  unit?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  roofCondition?: string;
  dateOfDamage?: string;
  typeOfDamaged?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  utm?: string;
  refId?: number;
  customerReferralName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Lead {
  id: number;
  uuid?: string;
  streetAddress?: string;
  unit?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  roofCondition?: string;
  dateOfDamage?: string;
  typeOfDamaged?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  utm?: string;
  refId?: number;
  customerReferralName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface InsuranceCompany {
  id?: number;
  companyName?: string;
  companyLogo?: string;
  claimLink?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProgressResetInput {
  id?: number;
  step?: string;
  status?: string;
}

export interface CreateLeadInput {
  streetAddress: string;
  unit: string;
  zipCode: string;
  city: string;
  state: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  utm?: string;
}

export interface CreateAdminUserInput {
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface EditAdminUserInput {
  id: number;
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface CreateInsuranceCompanyInput {
  companyName?: string;
  companyLogo?: string;
  claimLink?: string;
}

export interface insuranceCompaniesResponse {
  insuranceCompanies: InsuranceCompany[];
}

export interface ProjectsResponse {
  projects: Project[];
}

export interface ProductSystem {
  id: number;
  name: string;
  thumbnail?: string;
  duration?: string;
  priority?: number;
  archived?: boolean;
  rank?: number;
  isMaterialSelectionRequired?: boolean;
  isLaborSelectionRequired?: boolean;
}

export interface ListProductSystemsResponse {
  listProductSystems: ProductSystem[];
}

export interface LeadResponse {
  leads: LeadsData[];
}

export interface ProjectResponse {
  project: Project;
}

export interface AddonList {
  addons: Addon[];
}

export interface Addon {
  projectId: number;
  addonName: string;
  description: string;
  price: number;
  id: number;
}

export interface ProductsResponse {
  project: Product[];
}
export type PaymentType = "PERCENTAGE_OF_PROJECT_TOTAL" | "FIXED_AMOUNT";

export interface PaymentMethodInput {
  name: string;
  paymentType: PaymentType;
  amount: number;
  stepIndex: number;
}

export interface CreateNoteInput {
  projectId: number;
  title: string;
  notes: string;
}

export interface EditNoteInput {
  Id: number;
  title: string;
  notes: string;
}

export interface DeleteNoteInput {
  id: number;
}
export interface CreateProductSystemInput {
  name: string;
  // paymentMethods: PaymentMethodInput[];
  thumbnail?: string;
  duration?: string;
  // priority?: number!;
  rank: number;
  isMaterialSelectionRequired?: boolean;
  isLaborSelectionRequired?: boolean;
}

export interface UpdateProductInput {
  id: number;
  name?: string;
  thumbnail?: string;
  duration?: string;
  priority?: number;
  rank: number;
  isMaterialSelectionRequired?: boolean;
  isLaborSelectionRequired?: boolean;
}

export interface CreateProductSystemResponse {
  createProductSystem: boolean;
}

export interface CreateNotesResponse {
  CreateNote: boolean;
}

export interface EditNotesResponse {
  EditNote: boolean;
}

export interface DeleteNoteResponse {
  DeleteNote: boolean;
}

export interface UpdateProductSystemResponse {
  updateProduct: boolean;
}

export interface CreateMaterialCategoryInput {
  name: string;
}

export interface UpdateMaterialCategoryInput {
  id: number;
  name: string;
}

export interface CreateMaterialCategoryResponse {
  createMaterialCategory: boolean;
}
export interface UpdateMaterialCategoryResponse {
  updateMaterialCategory: boolean;
}

export interface CreateMiscFieldInput {
  name: string;
  showToCustomer: boolean;
  parentIds: number[];
}

export interface CreateMiscFieldResponse {
  createMiscField: boolean;
}

export interface CreateLaborMeasurementInput {
  name: string;
  unit: string;
  parentIds: number[];
}

export interface UpdateLaborMeasurementInput {
  id: number;
  name: string;
  unit: string;
  parentIds: number[];
}

export interface CreateLaborMeasurementResponse {
  createLaborMeasurement: boolean;
}

export interface UpdateLaborMeasurementResponse {
  updateLaborMeasurement: boolean;
}

export interface CreateMaterialMeasurementInput {
  name: string;
  customerDisplayName?: string;
  unit: string;
  parentIds: number[];
  categoryId: number;
  forceCustomerSelection: boolean;
}

export interface UpdateMaterialMeasurementInput {
  id: number;
  name: string;
  customerDisplayName?: string;
  unit: string;
  parentIds: number[];
  categoryId: number;
  forceCustomerSelection: boolean;
}

export interface MaterialsForProjectResponse {
  materialMeasurements: materialMeasurement[];
}

export interface MaterialsMeasurementDataResponse {
  materialMeasurements: MaterialMeasurementData[];
}

export interface MaterialMeasurementData {
  id: number;
  name: string;
  unit: string;
  parents: ParentData[];
  categoryId: number;
}

export interface ParentData {
  id: number;
  name: "string";
}

export interface LaborForProjectResponse {
  laborMeasurements: LaborMeasurement[];
}

export interface LaborMeasurement {
  id: number;
  name: string;
  unit: string;
  parents: Product[];
  createdAt: string;
  updatedAt: string;
}

export interface MaterialMeasurement {
  id: number;
  name: string;
  unit: string;
  parents: Product[];
  categoryId: number;
}

export interface CreateMaterialMeasurementResponse {
  createMaterialMeasurement: boolean;
}

export interface UpdateMaterialMeasurementResponse {
  updateMaterialMeasurement: boolean;
}

export interface UpdateMaterialInput {
  id: number;
  name: string;
  measurementId: number;
  brand: string;
  description: string;
  price: number;
  quality: string;
  measurementUnit: string;
  coverageAmount: number;
  addedImages?: string[];
  removedImages?: number[];
  tagIds?: number[];
  variants?: UpdateMaterialVariantInput[];
}

export interface CreateMaterialVariantInput {
  color: string;
  images: string[];
}

export interface UpdateMaterialVariantInput {
  color: string;
  images: string[];
}

export interface CreateMaterialInput {
  name: string;
  measurementId: number;
  brand: string;
  description: string;
  price: number;
  quality: string;
  measurementUnit: string;
  coverageAmount: number;
  images: string[];
  variants?: CreateMaterialVariantInput[];
  tagIds?: number[];
}

export interface CustomerProjects {
  customerId: number;
}

export interface CreateContractorResponse {
  createContractor: boolean;
}

export interface UpdateContractorResponse {
  updateContractor: boolean;
}

export interface getUploadUrlResponse {
  getUploadUrl: {
    url: string;
    typename?: string;
  };
}

export interface CreateContractorReportInput {
  name: string;
  responsibility: string;
  description: string;
  parentIds: number[];
}

export interface CreateContractorReportResponse {
  createContractorReport: boolean;
}

export interface CreateUploadFileInput {
  contentType: string;
}

export interface UploadUrl {
  url: string;
  fileName: string;
}

export interface uploadUrlResponse {
  createUploadUrl: UploadUrl;
}

export interface CreateMaterialResponse {
  createMaterial: boolean;
}

export interface UpdateMaterialResponse {
  updateMaterial: boolean;
}

export interface SignatureFieldInput {
  page: number;
  x: number;
  y: number;
}

export interface ContractorFieldInput {
  fieldType: ContractFieldType;
  page: number;
  x: number;
  y: number;
  width?: number;
  height?: number;
}

export enum ContractFieldType {
  CUSTOMER_NAME = "CUSTOMER_NAME",
  SHIPPING_ADDRESS = "SHIPPING_ADDRESS",
  DATE = "DATE",
  SIGNATURE = "SIGNATURE",
  INITIAL = "INITIAL",
  LINE_ITEMS = "LINE_ITEMS",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  AMOUNT = "AMOUNT"
}

export interface ContractorFileInput {
  name: string;
  description: string;
  url: string;
  fileType: FileType;
  id?: number;
  totalPages?: number;
  fields?: ContractorFieldInput[]; // New field structure
}

export interface ContractorTradeInput {
  id?: number;
  name: string;
  description: string;
  yearsOfDoing: number;
}

export interface UpdateContractorTradeInput {
  name: string;
  description: string;
  yearsOfDoing: number;
}

export type FileType = "PHOTO" | "LICENSE" | "DOCUMENT" | "LABOR_CONTRACT";

export interface CreateContractorInput {
  name: string;
  email?: string;
  website: string;
  description: string;
  files: ContractorFileInput[];
  trades: ContractorTradeInput[];
  parentIds: int[];
}

export interface UpdateContractorInput {
  id: number;
  name: string;
  email?: string;
  website: string;
  description: string;
  addedFiles: ContractorFileInput[];
  removedFiles: number[];
  updatedTrades: UpdateContractorTradeInput[];
  removedTrades: number[];
  parentIds: number[];
}

export interface CreateLaborResponse {
  createLabor: boolean;
}

export interface UpdateLaborResponse {
  updateLabor: boolean;
}

export interface CreateContractorChangeOrderResponse {
  createContractorOrder: boolean;
}

export interface CreateLaborVariantInput {
  productSystemId: number;
  price: number | null;
  description: string;
  measurementUnit: string;
  coverageAmount: number | null;
}

export interface UpdateLaborVariantInput {
  id: number;
  price?: number | null;
  description?: string;
  measurementUnit?: string;
  coverageAmount?: number | null;
}

export interface CreateLaborInput {
  description: string;
  price: number;
  measurementUnit: string;
  coverageAmount: number;
  contractorId: number;
  measurementId: number;
  parentIds: number[];
  newVariants?: CreateLaborVariantInput[];
  variantIds?: number[];
  // files: ContractorFileInput[];
}

export interface UpdateLaborInput {
  id: number;
  description: string;
  price: number;
  measurementUnit: string;
  coverageAmount: number;
  contractorId: number;
  measurementId: number;
  parentIds: number[];
  newVariants?: CreateLaborVariantInput[];
  updateVariants?: UpdateLaborVariantInput[];
  variantIds?: number[];
}

export interface CreateContractorOrderInput {
  name: string;
  materialPrice: number;
  laborPrice: number;
  materialId: number;
  laborId: number;
  parentIds: number[];
}

export interface ProjectMeasurementInput {
  projectId: number;
  measurementId: number;
  quantity: number;
}

export interface ArchiveProductSystemResponse {
  ToggleArchiveStatusProduct: boolean;
}

export interface ArchiveMaterialCategoryResponse {
  ArchiveMaterialCategory: boolean;
}

export interface ArchiveMaterialMeasurementResponse {
  ArchiveMaterialMeasurement: boolean;
}

export interface ArchiveMaterialResponse {
  ArchiveMaterial: boolean;
}

export interface ArchiveLaborMeasurementResponse {
  ArchiveLaborMeasurement: boolean;
}

export interface ArchiveContractorResponse {
  ArchiveContractor: boolean;
}

export interface ArchiveLaborResponse {
  ArchiveLabor: boolean;
}

export interface ArchiveMiscellaneousFieldResponse {
  ArchiveMiscellaneousField: boolean;
}

export interface LeadResponses {
  leadId: string;
}

export interface CreateAccountResponse {
  token: string;
  projectId: number;
  projectRefNumber: string;
}

export interface ProjectInputs {
  productIds: number[];
  paymentType: PayType;
}

export interface CreateCustomerInput {
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  phone: string;
  project?: ProjectInputs;
  leadId?: string;
  isAdmin?: boolean;
  placeId?: string;
}

export interface EditCustomer {
  customerId: number;
  firstName?: string;
  lastName?: string;
  phone?: string;
  addrId?: number;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  email?: string;
}

export interface UpdateProductSystemInput {
  productIds: number[];
  projectId: number;
}

export interface PaymentMethodUpdateInput {
  paymentType: PayType;
  projectId: number;
}

export interface UpdatePaymentMethodResponse {
  updatePaymentMethod: boolean;
}

export interface InsuranceCompaniesResponse {
  insuranceCompanies: InsuranceCompany[];
}

export interface NewProviderInput {
  name?: string;
  projectId: number;
  providerId?: number;
}

export enum Role {
  SALES = "SALES",
  ADMIN = "ADMIN",
  USER = "USER",
  AMBASSADOR = "AMBASSADOR",
  PROJECTMANAGER = "PROJECTMANAGER",
  CONCIERGE = "CONCIERGE",
  PROJECTSUPERVISOR = "PROJECTSUPERVISOR",
  PROJECTADMIN = "PROJECTADMIN"
}

export interface AssignToProject {
  adminId: number;
  projectId: number;
  role: Role;
}

export interface SlackChannelsResponse {
  slackChannels: string[];
}

export enum NotificationEvent {
  NEW_USER_CREATED = "NEW_USER_CREATED",
  PROCEEDED_TO_PROJECT_PLANNING = "PROCEEDED_TO_PROJECT_PLANNING", 
  UPLOADED_INSURANCE_SCOPE = "UPLOADED_INSURANCE_SCOPE",
  PROCEEDED_TO_ORDERING = "PROCEEDED_TO_ORDERING",
  SIGNED_ESTIMATE = "SIGNED_ESTIMATE",
  MADE_PAYMENT = "MADE_PAYMENT",
  PROCEEDED_TO_CONSTRUCTION = "PROCEEDED_TO_CONSTRUCTION",
  PROCEEDED_TO_COMPLETION = "PROCEEDED_TO_COMPLETION",
  TEST_NOTIFICATION = "TEST_NOTIFICATION"
}

export interface RecipientInput {
  recipientId: string;
  active: boolean;
  channel: string;
}

export interface TemplateInput {
  eventType: NotificationEvent;
  templateBody?: string;
  active: boolean;
  recipients: RecipientInput[];
}

export interface NotificationRecipient {
  id: number;
  recipientId: string;
  channel: string;
  active: boolean;
}

export interface NotificationWorkflow {
  id: number;
  eventType: string;
  templateBody?: string;
  active: boolean;
  recipients: NotificationRecipient[];
}

export interface WorkflowsResponse {
  getWorkflows: NotificationWorkflow[];
}

export interface AdminUsersResponse {
  adminUsers: AdminUser[];
}
